<template>
  <div class="box p-a">
    <transition 
      name="fade" 
      mode="out-in">
      <div 
        v-if="loading" 
        key="progress" 
        class="progress-container">
        <i class="fa fa-spinner fa-spin fa-2x"/>
      </div>
      <div 
        v-else 
        key="content" 
        class="content">
        <div class="pull-left m-r">
          <span 
            v-if="icon" 
            :class="iconClass">
            <i class="material-icons">{{ icon }}</i>
          </span>
        </div>
        <div class="clear">
          <span v-if="data != null">
            <h4 class="m-a-0 text-lg _300">{{ prefix }} {{ data }} {{ suffix }}</h4>
          </span>
          <span v-else>
            <h4 class="m-a-0 text-lg _300">{{ prefix }} 0 {{ suffix }}</h4>
          </span>
          <small class="text-muted">{{ subtitle }}</small>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Laravel from '../laroute';

export default {
    props: {
        prefix: {
            type: String,
            default: '',
        },
        suffix: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        route: {
            type: String,
            required: true,
        },
        outlet: {
            type: Number,
            default: 0,
        },
        icon: {
            type: String,
            default: null,
        },
        iconClass: {
            type: String,
            default: '',
        },
        start: {
            type: String,
            default: null,
        },
        end: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            data: null,
            loading: true,
        };
    },

    computed: {
        api() {
            return Laravel.route(this.route, { id: this.outlet });
        },
    },

    watch: {
        outlet() {
            this.getApiValue();
        },
    },

    created() {
        this.getApiValue();
    },

    methods: {
        getApiValue() {
            this.loading = true;

            let options = {
                params: this.getParams(),
            };

            this.$http.get(this.api, options).then(response => {
                this.data = response.data.data;
                this.loading = false;
            });
        },

        getParams() {
            let obj = {};

            let start = this.getStartDate();
            let end = this.getEndDate();

            if (start != null) {
                obj.start = start;
            }

            if (end != null) {
                obj.end = end;
            }

            return obj;
        },

        getDate(date) {
            if (date != null) {
                return m(date).format('YYYY-MM-DD hh:mm:ss');
            }

            return null;
        },

        getStartDate() {
            return this.getDate(this.start);
        },

        getEndDate() {
            return this.getDate(this.end);
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.progress-container {
    width: 100%;
    height: 47px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/MetricSummary.vue